import { render, staticRenderFns } from "./myOrderDetails.vue?vue&type=template&id=a5484742&scoped=true&"
import script from "./myOrderDetails.vue?vue&type=script&lang=js&"
export * from "./myOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./myOrderDetails.vue?vue&type=style&index=0&id=a5484742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5484742",
  null
  
)

export default component.exports